import React from "react";
import { Link } from "react-router-dom";
import Header from "../../components/LPHeader";
import Footer from "../../components/LPFooter";
import Image1 from "../../assets/images/highfive_no_bg.png";
import Image2 from "../../assets/images/table_laptop_no_bg_clean.png";
import { FaArrowRight } from "react-icons/fa";

const LPAboutUs = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white font-inter">
      <Header />
      <main className="flex-grow">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* --- Hero Section --- */}
          <div className="my-8 md:my-16">
            <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold pb-8 text-center md:text-left">
              About Us
            </h1>
            <div className="flex flex-col md:flex-row items-center gap-8">
              {/* --- Image Column --- */}
              <div className="w-full md:w-1/3 md:order-2">
                <img
                  src={Image2}
                  alt="Laptop and Table"
                  className="w-4/6 md:w-full h-auto mx-auto"
                />
              </div>
              {/* --- Text Column --- */}
              <div className="w-full md:w-1/2 text-center md:text-left md:order-1">
                <div className="max-w-lg mx-auto md:mx-0">
                  <h3 className="text-2xl md:text-4xl font-bold pb-4">
                    Our Mission
                  </h3>
                  <p className="text-base md:text-2xl pb-4">
                    We are building Scholarty to strengthen student life by
                    helping clubs and students connect, collaborate, and grow.
                  </p>
                  <p className="text-base md:text-2xl">
                    We aim to Simplify how organizations run and how students
                    find their place on campus all through one unified platform.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* --- Empowering & Built By Section --- */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 my-12 md:my-24 text-center md:text-left">
            <div>
              <h3 className="text-2xl md:text-4xl font-bold pb-4">
                Empowering Student Communities
              </h3>
              <p className="text-base md:text-2xl pb-4">
                From managing events to growing membership, we make it easier
                for student organizations to thrive. Students can discover
                clubs, track involvement, and participate in campus life with
                tools built for them.
              </p>
            </div>
            <div>
              <h3 className="text-2xl md:text-4xl font-bold pb-4">
                Built For Students, By Students
              </h3>
              <p className="text-base md:text-2xl pb-4">
                We're a team of students who have lived through the challenges
                of organizing and joining clubs. Scholarty is here to support
                student leaders, simplify club operations, and help students get
                more from their college experience.
              </p>
            </div>
          </div>

          {/* --- Join Us Section --- */}
          <div className="flex flex-col md:flex-row gap-8 my-12 md:my-16">
            <div className="w-full md:w-1/2 text-center md:text-left">
              <h2 className="text-4xl xl:text-5xl 2xl:text-6xl font-bold mb-4 ">
                Join Us on This Journey
              </h2>
              <p className="text-md xl:text-xl 2xl:text-2xl mb-6">
                Be part of Scholarty and help build the future of campus tech.
              </p>
              <Link
                to="/join-us"
                className="inline-flex items-center justify-center bg-[#5379F6] hover:bg-[#4A6ACB] text-white px-6 py-3 md:px-8 md:py-4 rounded-lg shadow-md transition duration-300 text-lg md:text-lg"
              >
                Join the Beta Test Waitlist <FaArrowRight className="ml-3" />
              </Link>
            </div>
            <div className="w-full md:w-1/3">
              <img
                src={Image1}
                alt="High Five"
                className="w-4/6 md:w-full h-auto mx-auto"
              />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
export default LPAboutUs;
